import { render, staticRenderFns } from "./workShop-add-or-update.vue?vue&type=template&id=0be37a94&scoped=true"
import script from "./workShop-add-or-update.vue?vue&type=script&lang=js"
export * from "./workShop-add-or-update.vue?vue&type=script&lang=js"
import style0 from "./workShop-add-or-update.vue?vue&type=style&index=0&id=0be37a94&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0be37a94",
  null
  
)

export default component.exports